const formatDuration = (seconds: number, tFunc: any) => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  let result = '';
  if (hours === 0 && minutes === 30) {
    return tFunc('duration.just_30min');
  }
  if (hours === 1) {
    result += ` ${tFunc('duration.1hr')} `;
  }
  if (hours === 2) {
    result += ` ${tFunc('duration.2hrs')} `;
  }
  if (hours > 2) {
    result += ` ${hours} ${tFunc('duration.hrs')} `;
  }
  if (minutes === 30) {
    result += tFunc('duration.30min');
  } else if (minutes > 0) {
    result += `${tFunc('duration.and')} ${minutes} ${tFunc('duration.min')}`;
  }
  return result;
};
const TimeUtils = {
  formatDuration,
};

export default TimeUtils;
